const CallSheetCard = (props: any) => {
  let title, address, phone, urlAvatar, project_managers;
  const defaultImage =
    "https://cinemahive.s3.amazonaws.com/images/logos/Company.png";

  // Props info
  if (props.currentProject?.company) {
    title = props.currentProject.company.company_name;
    address = props.currentProject.company.address;
    phone = props.currentProject.company.phone;
    urlAvatar = props.currentProject.company.url_file;
    project_managers = props.currentProject.project_managers;
  } else {
    // Get user from localStorage
    const userLocalStorage = window.localStorage.getItem("userInfo");
    if (userLocalStorage) {
      const userObj = JSON.parse(userLocalStorage);
      title = "My Project";
      phone = userObj.user.phone;
      urlAvatar = userObj.user.url_avatar;
    }
  }

  return (
    <div className="card">
      <div className="card-image">
        <img
          className="circle"
          src={urlAvatar ? urlAvatar : defaultImage}
          alt="user"
        />
      </div>
      <div className="card-information">
        <h4 className="card-information-title">{title}</h4>
        <p>{address}</p>
        {phone && <p>{`${phone} tel`}</p>}
      </div>
      {project_managers?.length > 0 && (
        <div className="card-information-contacts">
          <h4>Production Contacts</h4>
          {project_managers.map((contact: any) => (
            <p key={contact.user_id}>
              <span>{contact.full_name}</span>
              <span>{contact.phone}</span>
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default CallSheetCard;
